export const SET_PROFILE_EDIT = "SET_PROFILE_EDIT";
export const SET_PROFILE_EDIT_FALSE = "SET_PROFILE_EDIT_FALSE";
